import React from "react"
import * as Chakra from "@chakra-ui/react"
import { PressLessImage } from "../gatsby-image-svg-fallback"

interface ProjectCircularImagesProps {
  image1?: any
  image2?: any
  image3?: any
}

const ProjectCircularImages = React.forwardRef(
  (props: ProjectCircularImagesProps, ref) => {
    return (
      <Chakra.Box
        width="100%"
        display="flex"
        position="relative"
        alignItems="flex-start"
        flexDirection="column"
        backgroundColor="transparent"
        ref={ref}
      >
        <Chakra.Box
          width="100%"
          display="flex"
          maxWidth="1800px"
          alignItems="flex-start"
          marginLeft="auto"
          marginRight="auto"
          paddingLeft="40px"
          paddingRight="40px"
          flexDirection="column"
          paddingBottom="60px"
          backgroundColor="transparent"
          css={{
            "@media (max-width: 767px)": {
              paddingLeft: "20px",
              paddingRight: "20px",
            },
          }}
          className="project-block"
        >
          <Chakra.Box
            width="100%"
            display="flex"
            maxWidth="1128px"
            alignItems="flex-start"
            marginLeft="auto"
            marginRight="auto"
            flexDirection="row"
            justifyContent="space-between"
            css={{
              "@media (max-width: 767px)": {
                alignItems: "center",
                paddingTop: "41px",
                flexDirection: "column",
                paddingBottom: "32px",
                justifyContent: "center",
              },
            }}
          >
            <Chakra.Box
              width="30%"
              display="flex"
              clipPath="ellipse(100% 50% at 0% 50%)"
              transform="rotate(180deg)"
              minHeight="727px"
              alignItems="flex-end"
              flexDirection="column"
              justifyContent="flex-end"
              css={{
                "@media (max-width: 767px)": {
                  width: "70%",
                  minHeight: "727px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginBottom: "30px",
                },
                "@media (max-width: 479px)": {
                  width: "100%",
                },
              }}
            >
              <PressLessImage
                image={props.image1}
                transform="rotate(180deg)"
                alignSelf="flex-start"
                minHeight="727px"
                objectFit="cover"
                width="100%"
                css={{
                  "@media (max-width: 767px)": {
                    maxHeight: "auto",
                    minHeight: "727px",
                    objectFit: "cover",
                  },
                }}
              />
            </Chakra.Box>
            <Chakra.Box
              width="30%"
              display="flex"
              clipPath="ellipse(100% 50% at 0% 50%)"
              transform="rotate(180deg)"
              minHeight="727px"
              alignItems="flex-end"
              flexDirection="column"
              justifyContent="flex-end"
              css={{
                "@media (max-width: 767px)": {
                  width: "70%",
                  minHeight: "727px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginBottom: "30px",
                },
                "@media (max-width: 479px)": {
                  width: "100%",
                },
              }}
            >
              <PressLessImage
                image={props.image2}
                transform="rotate(180deg)"
                alignSelf="flex-start"
                minHeight="727px"
                objectFit="cover"
              />
            </Chakra.Box>
            <Chakra.Box
              width="30%"
              display="flex"
              clipPath="ellipse(100% 50% at 0% 50%)"
              transform="rotate(180deg)"
              minHeight="727px"
              alignItems="flex-end"
              flexDirection="column"
              justifyContent="flex-end"
              css={{
                "@media (max-width: 767px)": {
                  width: "70%",
                  minHeight: "727px",
                  marginLeft: "auto",
                  marginRight: "auto",
                },
                "@media (max-width: 479px)": {
                  width: "100%",
                },
              }}
            >
              <PressLessImage
                image={props.image3}
                transform="rotate(180deg)"
                alignSelf="flex-start"
                minHeight="727px"
                objectFit="cover"
              />
            </Chakra.Box>
          </Chakra.Box>
        </Chakra.Box>
      </Chakra.Box>
    )
  }
)

ProjectCircularImages.pressless = {
  name: "Project Circular Images",
  attributes: {
    image1: {
      name: "Image 1",
      type: "Image",
    },
    image2: {
      name: "Image 2",
      type: "Image",
    },
    image3: {
      name: "Image 3",
      type: "Image",
    },
  },
}
export default ProjectCircularImages
